// Core Imports
import { useEffect, useMemo } from 'react';
import './App.css';
import AppRoutes from './routers/AppRoutes';

// Redux Hooks and Actions
import { useDispatch, useSelector } from 'react-redux';
import { getnavigation, masterjson, setcountryDropdown, setcurrentcountry } from './redux/globalslice';
import { getalladdressesapi } from './redux/addresslice';
import { GetPlaceOrderapi } from "./redux/paymentslice";
import {
  getbannerList,
  getdeal_offersList,
  getDealOfTheDayList,
  getbundle_clearance_sale,
  getSaverZoneList,
  getTopSellingList,
  getTopPicksList,
  getbrand_week
} from './redux/homeslice';
import { setauthstatus, setlogindata, setformmodal, setformstatus } from "./redux/formslice";
import { cartlistapi, getWishLists } from "./redux/cartslice";

// Utilities and Hooks
import multi_countries from './json_data/multi_countries.json'
import axios from 'axios';
import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";
import Toast from './components/Common/Toast';
import { useAuth } from './hooks';
import { normalizeUrl } from './components/utils/helpers';

function App() {


// note : 

// if you deploying this project in other domain please add domain in multi_countries.json file  as new object or you can add in any of the existing object else it will not loaded it throws errror
// like bahrain.ourshopee.com must be in multi_countries.json using url property this project will run based on url multi_countries.json file
// for dev we defined different port number for diffrent countries 

// multi_countries.json has lot of configirations like is area country dropdown is reuired on country in register page , istabby required or not based on country








  const dispatch = useDispatch();

  // Redux State Selectors
  const authstatus = useSelector((state) => state.formslice.authstatus);
  const countryDropdown = useSelector((state) => state.globalslice.countryDropdown);
  const currentcountry = useSelector((state) => state.globalslice.currentcountry);
  const logindata = useSelector((state) => state.formslice.logindata);

  const { logout } = useAuth()

  // On App Load: Set Auth Status and Login Data from JWT Token if exists
  useMemo(() => {
    if (Cookies.get("jwt_token") !== undefined) {
      dispatch(setauthstatus(true))
      dispatch(setlogindata(jwtDecode(Cookies.get("jwt_token"))))
    }
  }, [])

  // On App Load: Set Country Dropdown Data from JSON (multicountries.json)
  useEffect(() => {
    dispatch(setcountryDropdown(multi_countries))
  }, []);

  // Set Current Country Based on URL and Country List
  useEffect(() => {
    // based on url we taking the current country from multi_countries.json file 
    // normalizeUrl function is for formatting the url like sometimes https://www.ourshopee.com , sometimes https://ourshopee.com user goes with this any url we have to come here only thats why we formatting 
    if (countryDropdown.length > 0) {
      let data;
      if (process.env.NODE_ENV === 'development') {
        data = countryDropdown.find(({ dev_url }) => dev_url === window.location.origin)
      } else if (process.env.NODE_ENV === 'production') {
        data = countryDropdown.find(({ url }) => url === normalizeUrl(window.location.origin))
      }
      dispatch(setcurrentcountry(data))
    }
  }, [countryDropdown])

  // Global Axios Response Interceptor: Handle 401 Errors (Session Expiry)
  axios.interceptors.response.use(
    function (response) {
      return response;
    },
    function (error) {
      if (error.response?.status === 401) {
        logout()
        dispatch(setformmodal(true));
        dispatch(setformstatus(1));
      }
    }
  );

  // On App Load: Fetch All Navigation & Home Page Data Lists(Apis)
  useMemo(() => {
    dispatch(getnavigation());
    dispatch(getdeal_offersList());
    dispatch(getbannerList());
    dispatch(getSaverZoneList());
    dispatch(getTopSellingList());
    dispatch(getDealOfTheDayList());
    dispatch(getTopPicksList());
    dispatch(getbrand_week());
    dispatch(getbundle_clearance_sale());
  }, [dispatch]);

  // On App Load: Again Validate JWT and Set Login Data (could probably merge with first one)
  useEffect(() => {
    const token = Cookies.get("jwt_token");
    if (token) {
      dispatch(setauthstatus(true));
      dispatch(setlogindata(jwtDecode(token)));
    }
  }, [dispatch]);

  // After JWT Token Change: Call Cart List API (Pass UserID or Cart IP)
  useEffect(() => {
    const input_data = {
      ip_address: Cookies.get("jwt_token") !== undefined ? 0 : Cookies.get("cart_ip_address"),
      user_id: Cookies.get("jwt_token") !== undefined ? jwtDecode(Cookies.get("jwt_token")).user_id : 0,
    };
    dispatch(cartlistapi(input_data));
  }, [Cookies.get("jwt_token")]);

  // When Auth Status Changes: Fetch User’s Address, Wishlist, and Order Info
  useMemo(() => {
    if (authstatus) {
      dispatch(getalladdressesapi(0));
      dispatch(getWishLists());
      dispatch(GetPlaceOrderapi(logindata.user_id));
    }
  }, [authstatus]);

  // Function: Dynamically Load Google Tag Manager Based on Current Country’s Tag ID
  function loadGTM(id) {
    const script = document.createElement('script');
    script.innerHTML = `
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;
      j.src='https://www.googletagmanager.com/gtm.js?id=' + i + dl;
      f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${id}');
    `;
    document.head.appendChild(script);

    const noscript = document.createElement('noscript');
    noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${id}"
      height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
    document.body.insertBefore(noscript, document.body.firstChild);
  }

  // Load GTM Script When Current Country Info is Available
  useEffect(() => {
    if (Object.keys(currentcountry).length > 0) {
      loadGTM(currentcountry.gtm_tag)
    }
  }, [currentcountry])

  // Render Application Routes and Global Toast Notifications After Country is Loaded
  return (
    <div className='mainbody'>
      {
        Object.keys(currentcountry).length > 0 &&
        <>
          <AppRoutes />
          <Toast />
        </>
      }
    </div>
  );
}

export default App;
